import React, { useContext } from 'react'
import { FaUserFriends, FaHome, FaVenus, FaVenusMars, FaBath } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'
import { Typography } from '@material-ui/core'
import { Context } from '../Store'

const WrapIcon = (props) => {
  if (props.noIcon) {
    return null
  }
  return props.children
}

const MatesNumber = ({ mates, t, noIcon }) => (
  <div className="flex flex-row items-center">
    <WrapIcon noIcon={noIcon}>
      <i className="mr-2 text-sm">
        <FaUserFriends />
      </i>
    </WrapIcon>
    <Typography variant="subtitle2">
      {mates} {mates > 1 ? t('propertyDetail.mate.plural') : t('propertyDetail.mate.singular')}
    </Typography>
  </div>
)

const PeopleNumber = ({ people, t, noIcon }) => (
  <div className="flex flex-row items-center">
    <WrapIcon noIcon={noIcon}>
      <i className="mr-2 text-sm">
        <FaUserFriends />
      </i>
    </WrapIcon>
    <Typography variant="subtitle2">
      {people} {people > 1 ? t('propertyDetail.people.plural') : t('propertyDetail.people.singular')}
    </Typography>
  </div>
)

const BathroomsNumber = ({ bathrooms, t, noIcon }) => (
  <div className="flex flex-row items-center">
    <WrapIcon noIcon={noIcon}>
      <i className="mr-2 text-sm">
        <FaBath />
      </i>
    </WrapIcon>
    <Typography variant="subtitle2">
      {bathrooms} {bathrooms > 1 ? t('propertyDetail.bath.plural') : t('propertyDetail.bath.singular')}
    </Typography>
  </div>
)

const Rooms = ({ bedrooms, t, noIcon }) => (
  <div className="flex flex-row items-center">
    <WrapIcon noIcon={noIcon}>
      <i className="mr-2 text-sm">
        <FaHome />
      </i>
    </WrapIcon>
    <Typography variant="subtitle2">
      {bedrooms} {bedrooms > 1 ? t('propertyDetail.room.plural') : t('propertyDetail.room.singular')}
    </Typography>
  </div>
)

const Gender = ({ gender, t, noIcon }) => {
  return (
    <div className="flex flex-row items-center">
      {gender === 'Female' && (
        <>
          <WrapIcon noIcon={noIcon}>
            <FaVenus className="text-sm mr-2" />
          </WrapIcon>
          <Typography variant="subtitle2">{t('propertyDetail.genderF')}</Typography>
        </>
      )}
      {gender === 'Male' && (
        <>
          <WrapIcon noIcon={noIcon}>
            <FaVenus className="text-sm mr-2" />
          </WrapIcon>
          <Typography variant="subtitle2">{t('propertyDetail.genderM')}</Typography>
        </>
      )}
      {gender === 'Any' && (
        <>
          <WrapIcon noIcon={noIcon}>
            <FaVenusMars className="text-sm mr-2" />
          </WrapIcon>
          <Typography variant="subtitle2">{t('propertyDetail.genderA')}</Typography>
        </>
      )}
    </div>
  )
}

const PropertyDetails = ({ noIcons, separator: Separator = () => <span /> }) => {
  const [state] = useContext(Context)
  const { type, mates, gender, baths: bathrooms, beds: bedrooms, visitors: people } = state.property
  const { i18n, t } = useTranslation()
  const { language } = i18n
  return (
    <>
      {type === 'Private Room' && (
        <>
          <MatesNumber mates={mates} language={language} noIcon={noIcons} t={t} />
          <Separator />
          <Gender gender={gender} language={language} noIcon={noIcons} t={t} />
          <Separator />
          <BathroomsNumber bathrooms={bathrooms} language={language} noIcon={noIcons} t={t} />
        </>
      )}
      {type === 'Entire Property' && (
        <>
          <Rooms bedrooms={bedrooms} language={language} noIcon={noIcons} t={t} />
          <Separator />
          <BathroomsNumber bathrooms={bathrooms} language={language} noIcon={noIcons} t={t} />
        </>
      )}
      {type === 'Shared Room' && (
        <>
          <MatesNumber mates={mates} language={language} noIcon={noIcons} t={t} />
          <Separator />
          <BathroomsNumber bathrooms={bathrooms} language={language} noIcon={noIcons} t={t} />
          <Separator />
          <Gender gender={gender} language={language} noIcon={noIcons} t={t} />
        </>
      )}
      {type === 'Studio' && (
        <>
          <PeopleNumber people={people} language={language} noIcon={noIcons} t={t} />
        </>
      )}
      {type === 'Villa' ||
        (type === 'Loft' && (
          <>
            <Rooms bedrooms={bedrooms} language={language} noIcon={noIcons} t={t} />
            <Separator />
            <BathroomsNumber bathrooms={bathrooms} language={language} noIcon={noIcons} t={t} />
          </>
        ))}
    </>
  )
}

export default PropertyDetails
